import React from 'react';
export default class InterstateSection extends React.Component {
    render() {
        return (
                <section id="interstate-section" className="section distribution-section interstate-section  d-flex align-items-center text-center">
                    <div className="container">
                      <img alt="interstate" src="/img/round_1.svg" />
                        <h2>
                            <span className="darkred">Interstate Orders</span>
                        </h2>
                        <p>
                            For interstate orders, our experienced freight partners offer fast and affordable delivery service to areas outside NSW. Please contact our office to discuss your options. 
                        </p>
                        <a href="#contact-us" className="btn">Contact Us</a>
                    </div>
                </section>
                )
    }
}



// WEBPACK FOOTER //
// ./src/components/Home/Interstate-Section.js